import { Typography } from 'antd';
import { EM_DASH, formatDateTime } from '@viq-admin/ui';
import { timeAgo } from './timeAgo';

/**
 * An exact date-time plus its age ("2h ago"), or `empty` when there is no
 * value. `stacked` puts the age on its own line, for narrow table cells;
 * otherwise it trails the date after a middle dot, for a Descriptions value.
 */
export function When({
  iso,
  empty = EM_DASH,
  stacked = false,
}: {
  iso: string | null | undefined;
  empty?: string;
  stacked?: boolean;
}) {
  const age = timeAgo(iso);
  if (!iso || !age) return <>{empty}</>;
  return (
    <span style={stacked ? { display: 'inline-flex', flexDirection: 'column' } : undefined}>
      <span>{formatDateTime(iso)}</span>
      <Typography.Text type="secondary">{stacked ? age : ` · ${age}`}</Typography.Text>
    </span>
  );
}
